import { render, staticRenderFns } from "./newuser.vue?vue&type=template&id=3feb2e63"
import script from "./newuser.vue?vue&type=script&lang=js"
export * from "./newuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports